import React, { Suspense, lazy, useEffect, useState } from "react";
import { Box, CircularProgress, Paper, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";

function useConsoleOutlet() {
  const ctx = useOutletContext() || {};
  return {
    registerRefresh: typeof ctx.registerRefresh === "function" ? ctx.registerRefresh : () => {},
    stopRefreshing: typeof ctx.stopRefreshing === "function" ? ctx.stopRefreshing : () => {},
    setGlobalError: typeof ctx.setGlobalError === "function" ? ctx.setGlobalError : () => {},
  };
}

const ApifacilInstancesPanel = lazy(() => import("./ApifacilInstancesPanel"));

function TabPanelSpinner() {
  return (
    <Box sx={{ py: 6, display: "flex", justifyContent: "center", alignItems: "center" }} role="status">
      <CircularProgress size={32} />
    </Box>
  );
}

export default function ApifacilInstancesSectionPage() {
  const { t } = useTranslation("app");
  const { registerRefresh, stopRefreshing } = useConsoleOutlet();
  const [panelKey, setPanelKey] = useState(0);

  useEffect(() => {
    registerRefresh(() => setPanelKey((k) => k + 1));
    return () => registerRefresh(() => stopRefreshing());
  }, [registerRefresh, stopRefreshing]);

  return (
    <Paper
      variant="outlined"
      sx={(theme) => ({
        bgcolor: alpha(theme.palette.primary.main, 0.03),
        borderColor: "divider",
        overflow: "hidden",
        p: 2.5,
      })}
    >
      <Typography variant="h6" sx={{ mb: 0.5 }}>
        {t("platformPage.tabApifacilInstances", { defaultValue: "Instâncias API Fácil" })}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t("platformPage.apifacilInstancesIntro", {
          defaultValue:
            "Gestão operacional das instâncias WhatsApp: o que está no Xpro, o que a API Fácil lista nos catálogos V1 e V2, e o que existe só de um lado.",
        })}
      </Typography>
      <Suspense fallback={<TabPanelSpinner />}>
        <ApifacilInstancesPanel key={panelKey} />
      </Suspense>
    </Paper>
  );
}
